import { render } from "./DashboardMain.vue?vue&type=template&id=52da4423"
import script from "./DashboardMain.vue?vue&type=script&lang=js"
export * from "./DashboardMain.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/DashboardMain.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "52da4423"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('52da4423', __exports__)) {
    api.reload('52da4423', __exports__)
  }
  
  module.hot.accept("./DashboardMain.vue?vue&type=template&id=52da4423", () => {
    api.rerender('52da4423', render)
  })

}


export default __exports__